import type { Route } from '@/types';
import type { NearbyRoutesResponse, NearbyRoutesParams } from './types';

/**
 * Fetches nearby transit routes from the API
 */
export async function fetchNearbyRoutes(params: NearbyRoutesParams): Promise<Route[]> {
  const { latitude, longitude, maxDistance } = params;
  const queryParams = `lat=${latitude}&lon=${longitude}&max_distance=${maxDistance}`;

  const response = await fetch(`/api/routes/nearby?${queryParams}`);

  if (!response.ok) {
    throw new Error(`Failed to fetch routes: ${response.status} ${response.statusText}`);
  }

  const data: NearbyRoutesResponse = await response.json();

  // Validate response data
  if (!data || !Array.isArray(data.routes)) {
    throw new Error('Invalid API response: routes array is missing or invalid');
  }

  // Filter out duplicate routes by global_route_id
  return filterDuplicateRoutes(data.routes);
}

/**
 * Removes duplicate routes based on global_route_id
 */
function filterDuplicateRoutes(routes: Route[]): Route[] {
  const seen = new Set<string>();
  return routes.filter((route) => {
    const id = String(route.global_route_id);
    if (seen.has(id)) {
      return false;
    }
    seen.add(id);
    return true;
  });
}
